module.exports = __webpack_public_path__ + "static/img/zuodun.f7a847d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zuodun.png
// module id = Pz7e
// module chunks = 1